import {
  sendApiRequest,
  sendApiClientRequest,
  sendApiClientRequestForArticle,
  sendEditApiClientRequestForArticle,
  sendApiClientRequestExcel,
  sendApiAIRequest,
  sendApiUsageRequest,
} from "./api";

export async function sendPostLogin(url, payload, isImage) {
  try {
    const response = await sendApiRequest("post", url, payload, isImage);
    return response;
  } catch (err) {
    console.error("error when posting data:", err);
    throw err;
  }
}

export async function sendGetRequest(url) {
  try {
    const response = await sendApiRequest("get", url);
    return response.data;
  } catch (err) {
    console.error("error when getting data:", err);
    throw err;
  }
}

export async function sendPostRequest(url, payload, isImage) {
  try {
    const response = await sendApiRequest("post", url, payload, isImage);
    return response.data;
  } catch (err) {
    console.error("error when posting data:", err);
    throw err;
  }
}

export async function sendPutRequest(url, payload, isImage) {
  try {
    const response = await sendApiRequest("put", url, payload, isImage);
    return response.data;
  } catch (err) {
    console.error("error when posting data:", err);
    throw err;
  }
}

export async function sendPatchRequest(url, payload, isImage) {
  try {
    const response = await sendApiRequest("patch", url, payload, isImage);
    return response.data;
  } catch (err) {
    console.error("error when posting data:", err);
    throw err;
  }
}

export async function sendDeleteRequest(url) {
  try {
    const response = await sendApiRequest("delete", url);
    return response.data;
  } catch (err) {
    console.error("error when posting data:", err);
    throw err;
  }
}

// CLIENT API
export async function sendGetClientRequest(url, responseType) {
  try {
    const response = await sendApiClientRequest(
      "get",
      url,
      null,
      false,
      responseType
    );
    return response.data;
  } catch (err) {
    console.error("error when getting data:", err);
    throw err;
  }
}

export async function sendGetClientRequestRaw(url, responseType) {
  try {
    const response = await sendApiClientRequest(
      "get",
      url,
      null,
      false,
      responseType
    );
    return response;
  } catch (err) {
    console.error("error when getting data:", err);
    throw err;
  }
}

export async function sendPostClientRequest(
  url,
  payload,
  isImage,
  responseType
) {
  try {
    const response = await sendApiClientRequest(
      "post",
      url,
      payload,
      isImage,
      responseType
    );
    return response.data;
  } catch (err) {
    console.error("error when posting data:", err);
    throw err;
  }
}

export async function sendPostClientRequestExcel(
  url,
  payload,
  isImage,
  responseType,
  downloadFileName
) {
  try {
    await sendApiClientRequestExcel(
      "post",
      url,
      payload,
      isImage,
      responseType,
      downloadFileName
    );
  } catch (err) {
    console.error("error when posting data:", err);
    throw err;
  }
}

export async function sendPostClientRequestForArticle(url, payload) {
  try {
    const response = await sendApiClientRequestForArticle("post", url, payload);
    return response.data;
  } catch (err) {
    console.error("error when posting data:", err);
    throw err;
  }
}

export async function sendPostEditClientRequestForArticle(url, payload) {
  try {
    const response = await sendEditApiClientRequestForArticle(
      "post",
      url,
      payload
    );
    return response.data;
  } catch (err) {
    console.error("error when posting data:", err);
    throw err;
  }
}

export async function sendDeleteClientRequest(url) {
  try {
    const response = await sendApiClientRequest("delete", url);
    return response.data;
  } catch (err) {
    console.error("error when posting data:", err);
    throw err;
  }
}

export async function sendPutClientRequest(url, payload, isImage) {
  try {
    const response = await sendApiClientRequest("put", url, payload, isImage);
    return response.data;
  } catch (err) {
    console.error("error when posting data:", err);
    throw err;
  }
}

export async function sendPatchClientRequest(url, payload, isImage) {
  try {
    const response = await sendApiClientRequest("patch", url, payload, isImage);
    return response.data;
  } catch (err) {
    console.error("error when posting data:", err);
    throw err;
  }
}

// USAGE API（用量管理後端）
export async function sendGetUsageRequest(url) {
  try {
    const response = await sendApiUsageRequest("get", url);
    return response?.data;
  } catch (err) {
    console.error("error when getting usage data:", err);
    throw err;
  }
}

export async function sendPutUsageRequest(url, payload) {
  try {
    const response = await sendApiUsageRequest("put", url, payload);
    return response?.data;
  } catch (err) {
    console.error("error when putting usage data:", err);
    throw err;
  }
}

export async function sendAIGetRequest(url) {
  try {
    const response = await sendApiAIRequest("get", url);
    return response.data;
  } catch (err) {
    console.error("error when getting data:", err);
    throw err;
  }
}

export async function sendAIPostRequest(url, payload, isImage, responseType) {
  try {
    const response = await sendApiAIRequest(
      "post",
      url,
      payload,
      isImage,
      responseType
    );
    return response.data;
  } catch (err) {
    console.error("error when posting data:", err);
    throw err;
  }
}
